import styled from "styled-components";

import { ExternalLink } from "ui/Link";
import { FBGroup } from "api/social-account-connect/facebook";

import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface FacebookGroupListProps {
  className?: string;
  groups: FBGroup[];
  onConnect(group: FBGroup): void;
  getConnectButtonState: GetConnectButtonState<FBGroup>;
}

export function FacebookGroupList({
  className,
  groups,
  onConnect,
  getConnectButtonState,
}: FacebookGroupListProps) {
  return (
    <Root className={className}>
      <h4>Select the Groups to add to Sked:</h4>
      <p>
        When you add a Group and publish content, we will publish to the Group
        as your individual 'profile' (person) as the administrator. Please get
        in touch with us if you would like to instead publish to the Facebook
        Group as your Facebook Page instead.
      </p>
      <AccountList
        items={groups}
        getConnectButtonState={getConnectButtonState}
        renderItemLabel={(group) => (
          <>
            {group.name} (
            <ExternalLink href={`https://facebook.com/${group.id}`}>
              {group.id}
            </ExternalLink>
            )
          </>
        )}
        onConnect={onConnect}
      />
      <Caption>
        Missing a Page? Check our access in{" "}
        <ExternalLink href="https://www.facebook.com/settings?tab=business_tools">
          Business Integrations on Facebook
        </ExternalLink>
        . Click 'view and edit' to make sure you have given us permission for
        the Pages and/or Instagram Accounts.
      </Caption>
    </Root>
  );
}

const Caption = styled.p`
  font-size: 14px;
`;

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;
